
import { Group, Product } from "@/lib/types";
import { GroupWithProducts } from "../GroupUsageCard";
import { ProductQuantity } from "@/components/group/GroupProductQuantities";
import { sortByUsageAndAlphabet, getGroupUsageCount, getProductUsageCount } from "@/lib/services/usageFrequencyService";

export const transformGroupsWithProducts = (
  groups: Group[],
  products: Product[],
  groupProductQuantities: Record<string, ProductQuantity[]>
): GroupWithProducts[] => {
  // Sort groups by usage frequency first
  const sortedGroups = sortByUsageAndAlphabet(groups, 'group', (group) => 
    getGroupUsageCount(group.id, products.filter(p => p.groupIds.includes(group.id)))
  );

  return sortedGroups.map(group => {
    // Get all products that belong to this group
    const groupProducts = products.filter(product => 
      group.productIds.includes(product.id)
    );
    
    // Sort products by usage frequency
    const sortedGroupProducts = sortByUsageAndAlphabet(groupProducts, 'product', (product) => 
      getProductUsageCount(product.id)
    );
    
    // Get saved quantities for this group
    const savedQuantities = groupProductQuantities[group.id] || [];
    
    // Map product IDs to their respective quantities
    const productsWithQuantity = sortedGroupProducts.map(product => {
      const savedQuantity = savedQuantities.find(sq => sq.productId === product.id);
      return {
        ...product,
        description: product.description || '', // Ensure description is not undefined
        quantity: savedQuantity ? savedQuantity.quantity : 1
      };
    });
    
    return {
      ...group,
      products: productsWithQuantity
    };
  });
};
